import { allExperiments } from './allExperiments/index.js';
export const getOptimizelyVariant = (experimentName) => {
    if (!(experimentName in allExperiments))
        return;
    const currExperiment = allExperiments[experimentName];
    const { experimentId, variantsIds } = currExperiment;
    const activeExperiments = window.optimizelyEdge?.get('state').getActiveExperiments() || {};
    if (activeExperiments[experimentId]) {
        const activeVariantId = activeExperiments[experimentId].variation.id;
        const variantKey = Object.keys(variantsIds).find((key) => variantsIds[key] === activeVariantId);
        return variantKey;
    }
};
//# sourceMappingURL=optimizelyExperiments.js.map